import DebugModal from './DebugModal'
import SummaryDebugView from './views/SummaryDebugView'

export default function SummaryDebugModal() {
  return (
    <DebugModal debugKey="summary" label="Summary">
      <SummaryDebugView />
    </DebugModal>
  )
}
